import { Menu, Paragraph, Table } from '@zillow/constellation-10';
import { useContext } from 'react';
import type { SatelliteWebLandlordGetLatestForContactsPageConversationDto } from '@zg-rentals/ts-satellite-client';
import { ModalType } from '../../../../types/ModalType';
import StringConstants from '../../../../constants/StringConstants';
import { AppContext } from '../../../../contexts/AppContextProvider';
import getApplicationActionText, { ACTION_TEXT } from '../../../../utils/getApplicationActionText';
import { TooltipWrapper } from '@zg-rentals/satellite-components';
import type { HandleOpenModal } from '../TableContent';

type Props = {
  isPhoneLead: boolean;
  onActionClick: HandleOpenModal;
  conversation: SatelliteWebLandlordGetLatestForContactsPageConversationDto;
};

export default function ActionMenuTableCell({ isPhoneLead, onActionClick, conversation }: Props) {
  const { isImpersonator, paths } = useContext(AppContext);
  const { isApplicationCompleted, isApplicationsAllowed, listingDetails, note } = conversation;
  const sendApplicationText = getApplicationActionText({
    isApplicationCompleted,
    hasSentApplication: note?.hasSentApplication ?? false,
  });
  const viewApplicationsForListingUrl =
    paths?.applicationsUrl && listingDetails?.listingAlias
      ? `${paths.applicationsUrl}/property/${listingDetails.listingAlias}`
      : '';

  const shouldShowViewApplicationAction =
    sendApplicationText === ACTION_TEXT.VIEW_APPLICATION && viewApplicationsForListingUrl;

  const handleSendApplicationClick = () => {
    return onActionClick(ModalType.SendApplicationConfirmationModal);
  };

  const handleSendMessageToLeadClick = () => {
    return onActionClick(ModalType.SendMessageModal);
  };

  const menu = (
    <>
      {isApplicationsAllowed && (
        <>
          {shouldShowViewApplicationAction && (
            <Menu.Item asChild>
              <a href={viewApplicationsForListingUrl} target="_blank" rel="noreferrer">
                {ACTION_TEXT.VIEW_APPLICATION}
              </a>
            </Menu.Item>
          )}

          {!shouldShowViewApplicationAction && sendApplicationText && (
            <TooltipWrapper
              wrapInTooltip={isImpersonator}
              tooltipText={StringConstants.TOOLTIP.IMPERSONATION}
              tooltipPlacement="top"
            >
              <Menu.Item disabled={isImpersonator} onClick={handleSendApplicationClick}>
                {sendApplicationText}
              </Menu.Item>
            </TooltipWrapper>
          )}
        </>
      )}
      <Menu.Item onClick={handleSendMessageToLeadClick}>Send message to lead</Menu.Item>
    </>
  );

  return (
    <Table.Cell css={{ verticalAlign: 'middle', textAlign: 'center' }}>
      {isPhoneLead ? (
        <Paragraph textStyle="body-xs">-</Paragraph>
      ) : (
        <Menu content={menu} css={{ fontFamily: 'sansSerif' }} />
      )}
    </Table.Cell>
  );
}
